export const STEPS = {
	BILLING: 'BILLING',
	PAYMENT: 'PAYMENT'
};
